const files = require.context('.', true, /\.js$/);
const modules = [];
import { requestDomain } from '../../../package.json';
files.keys().forEach(key => {
    if (key === './index.js') return;
    const item = files(key).default;
    const apiName = requestDomain + '/api/' + key.substring(2, key.lastIndexOf('/'));
    item.map(v => {
        v.url = apiName + v.url;
        return v;
    });
    modules.push(...item);
});

export default modules;
